<template>
    <Popover id="nav-bar" open="false" class="relative bg-navbar-brown">
        <div
            class="absolute inset-0 shadow z-20 pointer-events-none"
            aria-hidden="true"
        />
        <div class="relative">
            <div
                class="mx-auto flex justify-center items-center px-4 py-3 sm:px-6 sm:py-2 lg:px-8 md:justify-start md:space-x-10"
            >
                <div>
                    <a href="/" class="flex">
                        <span class="sr-only">Nutreance</span>
                        <svg-vue
                            class="hidden sm:block h-10 w-auto"
                            icon="logo"
                            aria-hidden="true"
                        />
                        <svg-vue
                            class="sm:hidden h-8 w-auto"
                            icon="logo-leaf"
                            aria-hidden="true"
                        />
                    </a>
                </div>

                <div
                    class="absolute inset-y-0 left-4 flex items-center md:hidden"
                >
                    <PopoverButton
                        v-if="showProductsMenu"
                        class="bg-navbar-brown rounded-md p-2 inline-flex items-center justify-center text-nutreance-brown-lighter hover:text-nutreance-brown focus:outline-none"
                    >
                        <span class="sr-only">Open menu</span>
                        <MenuIcon class="h-6 w-6" aria-hidden="true" />
                    </PopoverButton>
                    <a
                        v-else
                        :href="phoneLink"
                        class="rounded-md p-2 inline-flex items-center justify-center text-nutreance-brown-lighter hover:text-nutreance-brown focus:outline-none"
                    >
                        <PhoneIcon class="h-6 w-6" aria-hidden="true" />
                    </a>
                </div>

                <NavBarLeft
                    :headquarters="headquarters"
                    :isCustomer="isCustomer"
                    :isGuest="isGuest"
                    :loading="loading"
                    :phone="phone"
                    :phoneLink="phoneLink"
                    :product="product"
                    :productPages="productPages"
                    :productCategories="productCategories"
                    :showProductsMenu="showProductsMenu"
                />

                <NavBarRight
                    :initialCartQuantity="initialCartQuantity"
                    :csrf="csrf"
                    :isCustomer="isCustomer"
                    :isGuest="isGuest"
                    :userName="userName"
                    :canSeeAnyShipmentBatch="canSeeAnyShipmentBatch"
                    :canShopAsAnyCustomer="canShopAsAnyCustomer"
                    :canModerateReviews="canModerateReviews"
                    :shopAsCustomer="shopAsCustomer"
                    :shoppingAs="shoppingAs"
                    :showCart="showCart"
                />
            </div>
        </div>

        <NavBarLeftMobile
            :headquarters="headquarters"
            :is-guest="isGuest"
            :loading="loading"
            :phone="phone"
            :phoneLink="phoneLink"
            :product="product"
            :productPages="productPages"
            :product-categories="productCategories"
        />
    </Popover>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Popover, PopoverButton } from "@headlessui/vue";
import { MenuIcon } from "@heroicons/vue/outline";
import { PhoneIcon } from "@heroicons/vue/solid";
import NavBarLeft from "./NavBarLeft.vue";
import NavBarRight from "./NavBarRight.vue";
import NavBarLeftMobile from "./NavBarLeftMobile.vue";
import { useGooglePhoneConversion } from "../../functions/useGooglePhoneConversion";
import { loadProductCategories, loadProductPages } from "../../api/products";

const props = withDefaults(
    defineProps<{
        initialCartQuantity?: number;
        csrf?: string;
        headquarters?: any;
        userName?: string;
        isCustomer?: string;
        isGuest?: string;
        product?: any;
        canSeeAnyShipmentBatch?: string;
        canShopAsAnyCustomer?: string;
        canModerateReviews?: string;
        shopAsCustomer?: string;
        shoppingAs?: string;
        showCart?: string;
        showProductsMenu?: string;
    }>(),
    {
        showCart: "1",
        showProductsMenu: "1",
    },
);

const { phone, phoneLink, swapWithForwardingNumber } =
    useGooglePhoneConversion();
const loading = ref(true);
const productCategories = ref<any>(null);
const productPages = ref<any>(null);

loadProductCategories()
    .then((data) => {
        productCategories.value = data.productCategories;
    })
    .finally(() => (loading.value = false));

if (props.product) {
    loadProductPages(props.product.slug).then((data) => {
        productPages.value = data.productPages;
    });
}

phone.value = props.headquarters.phone;
phoneLink.value = props.headquarters.phoneLink;
swapWithForwardingNumber(props.headquarters.phone);
</script>
